import React from 'react'
import { ImageInner, ImageWrapper } from './Image.style'

type ImageProps = {
  src: string
  alt: string
  width?: number
  height?: number
  objectFit?: React.CSSProperties['objectFit']
  objectPosition?: React.CSSProperties['objectPosition']
  full?: boolean

  className?: string
}

export const Image: React.FC<ImageProps> = ({
  src,
  alt,
  width,
  height,
  objectFit,
  objectPosition,
  full,
  className,
}) => {
  return (
    <ImageWrapper
      width={width}
      height={height}
      className={className}
      full={full}
    >
      <ImageInner
        src={src}
        alt={alt}
        objectFit={objectFit}
        objectPosition={objectPosition}
        width={width}
        height={height}
        full={full}
      />
    </ImageWrapper>
  )
}
